export enum PriceDisplayTypes {
  MONTHLY = "min",
  MONTHLY_FROM = "abs_min"
}
